<template>
    <div class="spirit_">
      <h1>20XX年 宇宙の旅 (by Spirit)</h1><br>
      <el-table class="data-table" :data="tableData" stripe>
        <el-table-column prop="img_src" label="画像">
          <template slot-scope="scope">
            <img :src="scope.row.img_src" width="50%" height="50%"/>
          </template>
        </el-table-column>
        <el-table-column prop="earth_date" label="地球日付" width="150"></el-table-column>
        <el-table-column prop="sol" label="SOL" width="150"></el-table-column>
        <el-table-column prop="rover.name" label="ローバー名" width="150"></el-table-column>
        <el-table-column prop="rover.launch_date" label="ローバー開始日" width="150"></el-table-column>
        <el-table-column prop="rover.landing_date" label="ローバー着陸日" width="150"></el-table-column>
        <el-table-column prop="camera.full_name" label="カメラ名" width="150"></el-table-column>
      </el-table>
    </div>
</template>

<script>
const axios = require('axios').create()
export default {
  name: 'spirit_',
  data () {
    return {
      tableData: []
    }
  },
  mounted () {
    this.updataTableData()
  },
  methods: {
    updataTableData: async function () {
      const response = await axios.get('/api/nasa?rover_name=Spirit')
      this.tableData = response.data
    }
  }
}
</script>

<style scoped>
.data-table {
  width: 80%;
  margin: auto;
}
</style>
